import {Component, Injector, OnInit} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {ActivatedRoute, Router} from '@angular/router';
import {RoutesStorage} from '@helpers/routes.helper';
import {SelectValueInterface} from '@interfaces/select-value.interface';
import {OrganizationUserNamespace} from '@namespaces/organization-user.namespace';
import UserFormDataInterface = OrganizationUserNamespace.UserFormDataInterface;
import {FormHelperService} from '@services/form-helper.service';
import {UsersApiService} from '../services/users.api.service';

@Component({
    selector: 'app-users-invite',
    templateUrl: 'user-role-form.component.html',
    providers: [
    ]
})

export class UserRoleFormComponent extends FrontendFormComponent {
    roles: SelectValueInterface[] = [];
    user: UserFormDataInterface;

    form = this._fb.group({
        role: [''],
    });

    public listUrl = RoutesStorage.Organization.usersList;

    constructor(
        injector: Injector,
        public formService: UsersApiService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        super(injector);
    }

    get saveUrl() {
        return this.formService.getChangeRolePath(this.user && this.user.id);
    }

    init() {
        const roles: SelectValueInterface[] = this.route.snapshot.data.roles;
        this.user = this.route.snapshot.data.user;


        if (this.user) {
            FormHelperService.setFormValues(this.user, this.form);
        }

        if (roles && roles.length) {
            this.roles = roles;
        }
    }

    afterSave() {
        this.eventsService.notyShow$.next({
            content: 'Роль успешно сохранена',
            type: 'success',
            hideOnRouteChange: false,
        });
        this.router.navigate([this.listUrl]);
    }
}
